import api from '../api/api';

const state = () => ({
  category: null
})

const mutations = {
	setCategory(state, data) {
		state.category = data;
	}
}

const getters = {
  getCategory(state) {
      return state.category;
  },
	getCategoryPurchasePriceCalculate(state) {
		return state.category && state.category.success == true 
			? state.category.data.calculates.purchasePriceCalculate 
			: null;
	},
	getCategoryPriceCalculate(state) {
		return state.category && state.category.success == true 
			? state.category.data.calculates.priceCalculate 
			: null;
	},
	getCategoryHoldCalculate(state) {
		return state.category && state.category.success == true 
			? state.category.data.calculates.holdCalculate 
			: null;
	},
	getCategoryPercentCalculate(state) {
		return state.category && state.category.success == true 
			? state.category.data.calculates.percentCalculate 
			: null;
	},
	getAttributes(state) {
		return state.category && state.category.success == true && state.category.data.attributes
			? state.category.data.attributes
			: null
	}
}

const actions = {
    async GET_CATEGORY({commit}, data) {
			try {
				const categoryResponse = await api.categories.findOne(data.categoryId, data.queryParams);
				
				commit('setCategory', categoryResponse.data);

				return categoryResponse.data;
			} catch (err) {
				
				commit('setCategory', err.response);
				return err.response;
			}
    }
}


const purchase = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}

export default purchase;